import { IFinancialPlanQualityData } from '../../model/types'

const getOrder = (order: number | undefined): number => order ?? Number.POSITIVE_INFINITY

export const sortFinancialPlanQualityData = (
  data: IFinancialPlanQualityData[]
): IFinancialPlanQualityData[] =>
  data
    .map((row, sourceIndex) => ({ row, sourceIndex }))
    .sort(
      (left, right) =>
        getOrder(left.row.offeringOrder) - getOrder(right.row.offeringOrder) ||
        getOrder(left.row.order) - getOrder(right.row.order) ||
        left.sourceIndex - right.sourceIndex
    )
    .map(({ row }) => ({
      ...row,
      ...(row.children && { children: sortFinancialPlanQualityData(row.children) }),
    }))
